import React from 'react';
import { Typography, Tooltip, Box } from '@mui/material';
import { appColors } from '../../Config/Theme';
import { UI_STATUS_LABELS, UI_STATUS_HELP } from '../../Utils/headcountStatus';

interface NotCheckedIndicatorProps {
  showHelperText?: boolean;
}

const NotCheckedIndicator: React.FC<NotCheckedIndicatorProps> = ({ showHelperText = false }) => (
  <Tooltip title={UI_STATUS_HELP.notChecked} arrow>
    <Box sx={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <Typography
        variant="caption"
        sx={{
          fontSize: '0.7rem',
          fontWeight: 500,
          color: appColors.text.placeholder,
          fontStyle: 'italic',
          lineHeight: 1.3,
          userSelect: 'none',
        }}
      >
        {UI_STATUS_LABELS.notChecked}
      </Typography>
      {showHelperText && (
        <Typography
          variant="caption"
          sx={{
            fontSize: '0.6rem',
            color: appColors.text.placeholder,
            opacity: 0.7,
            lineHeight: 1.2,
          }}
        >
          No headcount action yet
        </Typography>
      )}
    </Box>
  </Tooltip>
);

export default NotCheckedIndicator;
